import { GuardStepResult } from "@rapid/hooks/useGuardStep";
import { Step } from "@rapid/types/flows";
import { useFlowState } from "@rapid/hooks/useFlowState";

export type UseGuardStep = (expectedStep: Step) => GuardStepResult;

export const useGuardSetupStep: UseGuardStep = () => {
    const { step } = useFlowState();

    return { loading: false, step, passThrough: true, errors: [], redirect: null };
};
